import React from 'react';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const NotFoundPage = () => {
    useDocumentTitle('Not Found Page');
    return (
        <ErrorPage
            code="404"
            title="Not Found"
            description="The page you were looking for is not found.<br/> You may have mistyped the address or the
            page may have moved.">
            <div className="not-found-icon text-center">
                <span className="fa-stack fa-5x w-100 mb-3">
                    <i className="fal fa-search fa-stack-2x text-primary" />
                    <i
                        className="fad fa-gift fa-stack-1x text-muted"
                        data-fa-transform="shrink-4 left-3 up-3"
                    />
                </span>
            </div>
        </ErrorPage>
    );
};
